import Vue from 'vue';
import { Toast } from 'vant';
import Dialog from 'vant/lib/dialog';
import Router from '@/router';
import sourceApi from '@/api/modules/source';
import { exitPage } from '@/utils/bridge.js';
import { track } from '@/directives/track/send.js';
import { actions as MiguActions } from './migu';
import { actions as CUCCActions } from './cucc';
import { actions as TELECOMActions } from './telecom';
import { checkMobile } from '@/api/modules/phone';
import { queryRingRel } from '@/api/modules/ringQuery';
import { CarrierType } from '@/model/CarrierType';
import { parseUrlParams, setParament } from '@/utils';
import { unicomWebLog } from '@/api/modules/unicom';
const ringTone = {
    namespaced: true,
    state: () => {
        return {
            carrierType: localStorage.getItem('userType') || CarrierType.MIGU,
            phoneProvince: '',
            phone: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo') || '{}').phone : '',
            oneClickPhone: localStorage.getItem('oneClickPhone') || '',
            tipShow: false,
            sourceChange: !!sessionStorage.getItem('sourceChange'),
            // 订购所需数据
            settingData: {
                videoId: '',
                productId: '',
                copyRightID: '',
                contentId: '',
                sourceType: '',
                songName: '',
                channelName: '',
                actorName: '',
                desc: ''
            },
            changePhone: false,
            // 记录订购流程经过几个页面。
            historyPage: [],
            statusheightShow: false,
            // 是否有取消的订单
            hasCancelOrder: false,
            retentionOrderParams: {
                videoId: '',
                productId: '',
                copyRightID: '',
                contentId: '',
                sourceType: '',
                desc: '',
                phone: ''
            },
            checkPhoneCarrierType: JSON.parse(window.localStorage.getItem('checkPhoneCarrierType') || '{}'),
            openRetention: false,
            channelCodeH: '',
            channelCodeHCopy: '',
            serviceIdHCopy: '',
            serviceIdH: '',
            serviceIdG: '600923018000000006,698039035100000014',
            channelCodeG: '',
            channelCodeGCopy: '',
            oldStatus: -1
        };
    },
    mutations: {
        SET_OLD_STATUS(state, oldStatus) {
            state.oldStatus = oldStatus;
        },
        SET_OPEN_RETENTION(state, flag) {
            state.openRetention = flag;
        },
        SET_PHONE_PROVINCE(state, province) {
            state.phoneProvince = province;
        },
        SET_TIPSHOW: (state, isShow) => {
            state.tipShow = isShow;
        },
        SET_HAS_CANCEL_ORDER(state, hasCancelOrder) {
            state.hasCancelOrder = hasCancelOrder;
        },
        SET_RETENTION_ORDER_PARAMS(state, data) {
            const { videoId, productId, copyRightID, sourceType, desc, phone } = data;
            state.retentionOrderParams.videoId = videoId;
            state.retentionOrderParams.productId = productId;
            state.retentionOrderParams.copyRightID = copyRightID;
            state.retentionOrderParams.contentId = videoId;
            state.retentionOrderParams.sourceType = sourceType;
            state.retentionOrderParams.desc = desc;
            state.retentionOrderParams.phone = phone;
        },
        SET_STATUSDIV(state, data) {
            state.statusheightShow = data;
        },
        // 运营商
        SET_CARRIER_TYPE: (state, data) => {
            state.carrierType = data;
            window.localStorage.setItem('userType', data);
            if (state.phone) {
                Vue.set(state.checkPhoneCarrierType, state.phone, data);
                const obj = JSON.parse(JSON.stringify(state.checkPhoneCarrierType));
                obj[state.phone] = data;
                window.localStorage.setItem('checkPhoneCarrierType', JSON.stringify(obj));
            }
        },
        // 一键登录获取手机号
        SET_ONE_CLICK_PHONE: (state, data) => {
            state.oneClickPhone = data;
            state.phone = data;
            window.localStorage.setItem('oneClickPhone', data);
        },
        // 当前使用的手机号
        SET_PHONE: (state, data) => {
            // 如果清除了 则将手机号设置为一键登录的手机号
            if (!data && state.oneClickPhone) {
                state.phone = state.oneClickPhone;
            }
            else {
                state.phone = data;
            }
        },
        // 更换手机号
        SET_CHANGE_PHONE(state, changePhone) {
            state.changePhone = changePhone;
        },
        // 设置彩铃信息
        SET_SETTING_DESC(state, title) {
            state.settingData.desc = title;
        },
        SET_SETTING_CHANNEL(state, name) {
            state.settingData.channelName = name;
        },
        SET_SETTING_SONG_NAME(state, songName) {
            state.settingData.songName = songName;
        },
        SET_SETTING_ACTOR_NAME(state, actorName) {
            state.settingData.actorName = actorName;
        },
        SET_SETTING_SOURCETYPE(state, sourceType) {
            state.settingData.sourceType = sourceType;
        },
        SET_SETTING_VIDEOID(state, ringId) {
            state.settingData.videoId = ringId;
        },
        SET_SETTING_PRODUCT_ID(state, productId) {
            state.settingData.productId = productId;
        },
        SET_SETTING_CONTENT_ID(state, contentId) {
            state.settingData.contentId = contentId;
        },
        SET_SETTING_CROPYRINGHT_ID(state, copyRightID) {
            state.settingData.copyRightID = copyRightID;
        },
        SET_SETTING_SEARCH_KEY(state, searchkey) {
            state.settingData.searchkey = searchkey;
        },
        // 记录订购流程经过那几个页面。需要go（-num）回到详情页
        SET_HISTORY_PAGE(state, list) {
            Vue.set(state, 'historyPage', list);
        },
        PUSH_HISTORY_PAGE(state, pageName) {
            state.historyPage.push(pageName);
        },
        POP_HISTORY_PAGE1(state) {
            state.historyPage.pop();
        },
        POP_HISTORY_PAGE(state, pageName) {
            const current = state.historyPage[state.historyPage.length - 2];
            if (pageName === current) {
                state.historyPage.pop();
            }
        },
        // 回到详情页时 重置记录
        DELETE_HISTORY_PAGE(state) {
            state.historyPage.splice(0);
        },
        SET_SOURCE_CHANGE(state, sourceChange) {
            state.sourceChange = sourceChange;
            window.sessionStorage.setItem('sourceChange', sourceChange);
        },
        // 有功能渠道号
        SET_HAS_STATUS(state, channelData) {
            state.channelCodeH = channelData.channelCode;
            state.serviceIdH = channelData.serviceIdH5;
        },
        // 无功能渠道号
        SET_NONE_STATUS(state, key) {
            state.channelCodeG = key;
        },
        // 有功能渠道号备份
        SET_HAS_STATUS_COPY(state, channelData) {
            state.channelCodeHCopy = channelData.channelCode;
            state.serviceIdHCopy = channelData.serviceIdH5;
        },
        // 有功能渠道号备份
        SET_NONE_STATUS_COPY(state, key) {
            state.channelCodeGCopy = key;
        }
    },
    actions: {
        ...MiguActions,
        ...CUCCActions,
        ...TELECOMActions,
        cuccSubmitPoint({ state, dispatch, rootState }, payload) {
            const data = setParament({
                ...payload,
                phone: state.phone
            });
            unicomWebLog(data).then(res => {
                console.log(res);
            });
        },
        showTip({ state, dispatch, rootState }, carrierType) {
            let process = {
                page: false,
                dialog: false,
                rules: '',
                protocolStatus: false,
                dialogTitle: '',
                dialogContent: '',
                dialogBtn: ''
            };
            if (rootState.app.processConfig[carrierType]) {
                process = rootState.app.processConfig[carrierType];
            }
            else {
                process = rootState.app.processConfig[state.carrierType];
            }
            const params = {
                h5_color_ring_general_popup_event_type: '1',
                h5_color_ring_general_popup_type: '7',
                popup_title: ''
            };
            if (state.carrierType === CarrierType.CUCC || carrierType === CarrierType.CUCC) {
                const title = process.dialogTitle ? process.dialogTitle : '业务订购申请已提交';
                const message = process.dialogContent ? process.dialogContent : '业务订购生效将以短信告知，生效后即可设置视频彩铃啦，请耐心等待哦~~';
                const confirmButtonText = process.dialogBtn ? process.dialogBtn : '我知道了';
                Dialog.alert({
                    title,
                    message,
                    confirmButtonText,
                    className: 'success-order-dialog',
                    beforeClose: (_, done) => {
                        done();
                        if (Router.currentRoute.query.tabType === 'tab-home') {
                            exitPage();
                        }
                    }
                });
                params.popup_title = '中国联通';
                track([{ event_id: 'h5_color_ring_general_popup', event_param: params }]);
            }
            else if (state.carrierType === CarrierType.TELECOM || carrierType === CarrierType.TELECOM) {
                const title = process.dialogTitle ? process.dialogTitle : '设置已提交';
                const message = process.dialogContent ? process.dialogContent : '24小时内生效,请留意设置成功短信通知';
                const confirmButtonText = process.dialogBtn ? process.dialogBtn : '我知道了';
                Dialog.alert({
                    title,
                    message,
                    confirmButtonText,
                    className: 'success-order-dialog',
                    beforeClose: (_, done) => {
                        done();
                        if (Router.currentRoute.query.tabType === 'tab-home') {
                            exitPage();
                        }
                    }
                });
                params.popup_title = '中国电信';
                track([{ event_id: 'h5_color_ring_general_popup', event_param: params }]);
            }
            else {
                const title = process.dialogTitle ? process.dialogTitle : '设置已提交';
                const tem = process.dialogContent ? process.dialogContent : '24小时内生效,请留意设置成功短信通知';
                const confirmButtonText = process.dialogBtn ? process.dialogBtn : '我知道了';
                const message = tem.replace('s1', state.settingData.channelName).replace('s2', state.settingData.desc);
                Dialog.alert({
                    title,
                    message,
                    confirmButtonText,
                    className: 'success-order-dialog',
                    beforeClose: (_, done) => {
                        done();
                        if (Router.currentRoute.query.tabType === 'tab-home') {
                            exitPage();
                        }
                    }
                });
                params.popup_title = '中国移动';
                track([{ event_id: 'h5_color_ring_general_popup', event_param: params }]);
            }
            dispatch('loginConfirm');
        },
        getChannelCode({ commit, state, rootState }, payload) {
            return new Promise((resolve, reject) => {
                const curerntPageParams = parseUrlParams(location.href);
                checkMobile({
                    phone: payload,
                    pcid: curerntPageParams.pcid
                })
                    .then(res => {
                    // 异常处理
                    if (res.code === '5000') {
                        Toast.fail({
                            message: res.message
                        });
                        reject(res.message);
                    }
                    else {
                        // 正常返回。但针对广电提醒 && (status === 1)
                        const { type, detail, status } = res.data;
                        if (type === CarrierType.CBN) {
                            Toast.fail({
                                message: '快换移动号，广电设置不了'
                            });
                            reject(res.message);
                        }
                        else if (status === 1) {
                            const isSame = type === state.carrierType;
                            const province = detail[0];
                            commit('SET_CARRIER_TYPE', type);
                            commit('SET_PHONE_PROVINCE', province);
                            // 判断使用哪个渠道号 ring_mobile_province_channel
                            // 根据pcid判断使用哪一套渠道号,
                            // 配置手机号归属的渠道号使用
                            const tablesr = rootState.app.configData.ring_mobile_province_channel;
                            if (tablesr) {
                                const table = JSON.parse(tablesr);
                                const keys = Object.keys(table);
                                for (const key of keys) {
                                    if (key.includes(province)) {
                                        // 第一个有功能，第二个没有功能
                                        if (table[key] && table[key].length) {
                                            const [key1, key2] = table[key];
                                            const jsonstr = rootState.app.configData[key1];
                                            const jsonstr2 = rootState.app.configData[key2];
                                            if (jsonstr) {
                                                try {
                                                    const channelData = JSON.parse(jsonstr);
                                                    commit('SET_HAS_STATUS', channelData);
                                                }
                                                catch (err) {
                                                    console.log(err);
                                                }
                                            }
                                            if (jsonstr2) {
                                                try {
                                                    const channelData = JSON.parse(jsonstr2);
                                                    commit('SET_NONE_STATUS', channelData.channelCode);
                                                }
                                                catch (err) {
                                                    console.log(err);
                                                }
                                            }
                                        }
                                        break;
                                    }
                                }
                            }
                            debugger;
                            if (!state.channelCodeH || !state.channelCodeG) {
                                if (curerntPageParams.pcid && curerntPageParams.pcid.startsWith('ot')) {
                                    // 使用主题的渠道号
                                    const hkey = rootState.app.configData.ring_mobile_theme_channel_key1;
                                    if (hkey) {
                                        const jsonstr = rootState.app.configData[hkey];
                                        if (jsonstr) {
                                            try {
                                                const channelData = JSON.parse(jsonstr);
                                                commit('SET_HAS_STATUS', channelData);
                                            }
                                            catch (err) {
                                                console.log(err);
                                            }
                                        }
                                    }
                                    else {
                                        commit('SET_HAS_STATUS', {
                                            channelCode: '00211IV',
                                            serviceIdH5: '698039042105792434'
                                        });
                                    }
                                    const gkey = rootState.app.configData.ring_mobile_theme_channel_key2;
                                    if (gkey) {
                                        const jsonstr = rootState.app.configData[gkey];
                                        if (jsonstr) {
                                            try {
                                                const channelData = JSON.parse(jsonstr);
                                                commit('SET_NONE_STATUS', channelData.channelCode);
                                            }
                                            catch (err) {
                                                console.log(err);
                                            }
                                        }
                                    }
                                    else {
                                        commit('SET_NONE_STATUS', '00211IU');
                                    }
                                }
                                else {
                                    // 默认使用渠道号    // 使用oppo音乐的渠道号
                                    const hkey = rootState.app.configData.ring_mobile_channel_key1;
                                    if (hkey) {
                                        const jsonstr = rootState.app.configData[hkey];
                                        if (jsonstr) {
                                            try {
                                                const channelData = JSON.parse(jsonstr);
                                                commit('SET_HAS_STATUS', channelData);
                                            }
                                            catch (err) {
                                                console.log(err);
                                            }
                                        }
                                    }
                                    else {
                                        commit('SET_HAS_STATUS', {
                                            channelCode: '00211IV',
                                            serviceIdH5: '698039042105792434'
                                        });
                                    }
                                    const gkey = rootState.app.configData.ring_mobile_channel_key2;
                                    if (gkey) {
                                        const jsonstr = rootState.app.configData[gkey];
                                        if (jsonstr) {
                                            try {
                                                const channelData = JSON.parse(jsonstr);
                                                commit('SET_NONE_STATUS', channelData.channelCode);
                                            }
                                            catch (err) {
                                                console.log(err);
                                            }
                                        }
                                    }
                                    else {
                                        commit('SET_NONE_STATUS', '00211IU');
                                    }
                                }
                            }
                            resolve({ type, isSame });
                        }
                        else {
                            const message = `抱歉，您所在的区域${detail[0] ? `(${detail[0]})` : ''}暂时不支持使用该视频彩铃服务，敬请谅解！`;
                            Toast.fail({
                                message
                            });
                            reject(res.message);
                        }
                    }
                }).catch(() => {
                    Toast.clear();
                });
            });
        },
        // 运营商检查 检查运营商同时得出 改手机号归属 使用哪个渠道号
        checkMobileActions({ commit, dispatch, state, rootState }, payload) {
            // dispatch('checkMobileTrack', { type: '10', res: '', isSuccess: false, carrierName: '' })
            // dispatch('handleActionApi', {
            //   isp: '',
            //   token: '',
            //   phone: payload,
            //   action: '10',
            //   interfaceName: 'api/checkMobile',
            //   resCode: '',
            //   resMessage: ''
            // })
            return new Promise((resolve, reject) => {
                const curerntPageParams = parseUrlParams(location.href);
                checkMobile({
                    phone: payload,
                    pcid: curerntPageParams.pcid
                })
                    .then(res => {
                    // 异常处理
                    if (res.code === '5000') {
                        Toast.fail({
                            message: res.message
                        });
                        dispatch('checkMobileTrack', {
                            type: '11',
                            res,
                            isSuccess: false,
                            carrierName: ''
                        });
                        dispatch('handleActionApi', {
                            isp: '',
                            uid: rootState.app.selfInfo.uid,
                            token: '',
                            phone: payload,
                            action: '11',
                            interfaceName: 'api/checkMobile',
                            resCode: res.code,
                            resMessage: JSON.stringify(res)
                        });
                        reject(res.message);
                    }
                    else {
                        // 正常返回。但针对广电提醒 && (status === 1)
                        const { type, detail, status, mobile } = res.data;
                        let message = '';
                        if (status === 1) {
                            message = `${detail[0] ? `${detail[0]}` : ''}-type:${type}-status:${status}-phone:${mobile}`;
                        }
                        else {
                            message = `${detail[0] ? `${detail[0]}省份限制` : ''},手机号:${mobile}-type:${type}-status:${status}`;
                        }
                        dispatch('checkMobileTrack', {
                            type: '11',
                            res: message,
                            isSuccess: (res.code === '0000'),
                            carrierName: type
                        });
                        dispatch('handleActionApi', {
                            isp: CarrierType.ENUM[type],
                            token: '',
                            phone: payload,
                            action: '11',
                            interfaceName: 'api/checkMobile',
                            resCode: res.code,
                            resMessage: JSON.stringify(res)
                        });
                        if (type === CarrierType.CBN) {
                            Toast.fail({
                                message: '快换移动号，广电设置不了'
                            });
                            reject(res.message);
                        }
                        else if (status === 1) {
                            const isSame = type === state.carrierType;
                            const province = detail[0];
                            commit('SET_CARRIER_TYPE', type);
                            commit('SET_PHONE_PROVINCE', province);
                            // 判断使用哪个渠道号 ring_mobile_province_channel
                            // 根据pcid判断使用哪一套渠道号,
                            // 配置手机号归属的渠道号使用
                            const tablesr = rootState.app.configData.ring_mobile_province_channel;
                            if (tablesr) {
                                const table = JSON.parse(tablesr);
                                const keys = Object.keys(table);
                                for (const key of keys) {
                                    if (key.includes(province)) {
                                        // 第一个有功能，第二个没有功能
                                        if (table[key] && table[key].length) {
                                            const [key1, key2] = table[key];
                                            const jsonstr = rootState.app.configData[key1];
                                            const jsonstr2 = rootState.app.configData[key2];
                                            if (jsonstr) {
                                                try {
                                                    const channelData = JSON.parse(jsonstr);
                                                    commit('SET_HAS_STATUS', channelData);
                                                    commit('SET_HAS_STATUS_COPY', channelData);
                                                }
                                                catch (err) {
                                                    console.log(err);
                                                }
                                            }
                                            if (jsonstr2) {
                                                try {
                                                    const channelData = JSON.parse(jsonstr2);
                                                    commit('SET_NONE_STATUS', channelData.channelCode);
                                                    commit('SET_NONE_STATUS_COPY', channelData.channelCode);
                                                }
                                                catch (err) {
                                                    console.log(err);
                                                }
                                            }
                                        }
                                        break;
                                    }
                                }
                            }
                            debugger;
                            if (!state.channelCodeH || !state.channelCodeG) {
                                if (curerntPageParams.pcid && curerntPageParams.pcid.startsWith('ot')) {
                                    // 使用主题的渠道号
                                    const hkey = rootState.app.configData.ring_mobile_theme_channel_key1;
                                    if (hkey) {
                                        const jsonstr = rootState.app.configData[hkey];
                                        if (jsonstr) {
                                            try {
                                                const channelData = JSON.parse(jsonstr);
                                                commit('SET_HAS_STATUS', channelData);
                                                commit('SET_HAS_STATUS_COPY', channelData);
                                            }
                                            catch (err) {
                                                console.log(err);
                                            }
                                        }
                                    }
                                    else {
                                        commit('SET_HAS_STATUS', {
                                            channelCode: '00211IV',
                                            serviceIdH5: '698039042105792434'
                                        });
                                        commit('SET_HAS_STATUS_COPY', {
                                            channelCode: '00211IV',
                                            serviceIdH5: '698039042105792434'
                                        });
                                    }
                                    const gkey = rootState.app.configData.ring_mobile_theme_channel_key2;
                                    if (gkey) {
                                        const jsonstr = rootState.app.configData[gkey];
                                        if (jsonstr) {
                                            try {
                                                const channelData = JSON.parse(jsonstr);
                                                commit('SET_NONE_STATUS', channelData.channelCode);
                                                commit('SET_NONE_STATUS_COPY', channelData.channelCode);
                                            }
                                            catch (err) {
                                                console.log(err);
                                            }
                                        }
                                    }
                                    else {
                                        commit('SET_NONE_STATUS', '00211IU');
                                        commit('SET_NONE_STATUS_COPY', '00211IU');
                                    }
                                }
                                else {
                                    // 默认使用渠道号    // 使用oppo音乐的渠道号
                                    const hkey = rootState.app.configData.ring_mobile_channel_key1;
                                    if (hkey) {
                                        const jsonstr = rootState.app.configData[hkey];
                                        if (jsonstr) {
                                            try {
                                                const channelData = JSON.parse(jsonstr);
                                                commit('SET_HAS_STATUS', channelData);
                                                commit('SET_HAS_STATUS_COPY', { ...channelData });
                                            }
                                            catch (err) {
                                                console.log(err);
                                            }
                                        }
                                    }
                                    else {
                                        commit('SET_HAS_STATUS', {
                                            channelCode: '00211IV',
                                            serviceIdH5: '698039042105792434'
                                        });
                                        commit('SET_HAS_STATUS_COPY', {
                                            channelCode: '00211IV',
                                            serviceIdH5: '698039042105792434'
                                        });
                                    }
                                    const gkey = rootState.app.configData.ring_mobile_channel_key2;
                                    if (gkey) {
                                        const jsonstr = rootState.app.configData[gkey];
                                        if (jsonstr) {
                                            try {
                                                const channelData = JSON.parse(jsonstr);
                                                commit('SET_NONE_STATUS', channelData.channelCode);
                                                commit('SET_NONE_STATUS_COPY', channelData.channelCode);
                                            }
                                            catch (err) {
                                                console.log(err);
                                            }
                                        }
                                    }
                                    else {
                                        commit('SET_NONE_STATUS', '00211IU');
                                        commit('SET_NONE_STATUS_COPY', '00211IU');
                                    }
                                }
                            }
                            // 老用户使用老渠道号G、H，默认H登录ring_mobile_channel_key_002111H、ring_mobile_channel_key_002111G
                            commit('SET_OLD_STATUS', res.data.oldStatus);
                            if (res.data.oldStatus === 1) {
                                const jsonstr = rootState.app.configData.ring_mobile_channel_key_002111H;
                                const jsonstr2 = rootState.app.configData.ring_mobile_channel_key_002111G;
                                if (jsonstr) {
                                    try {
                                        const channelData = JSON.parse(jsonstr);
                                        commit('SET_HAS_STATUS', channelData);
                                    }
                                    catch (err) {
                                        console.log(err);
                                    }
                                }
                                if (jsonstr2) {
                                    try {
                                        const channelData = JSON.parse(jsonstr2);
                                        commit('SET_NONE_STATUS', channelData.channelCode);
                                    }
                                    catch (err) {
                                        console.log(err);
                                    }
                                }
                            }
                            resolve({ type, isSame });
                        }
                        else {
                            const message = `抱歉，您所在的区域${detail[0] ? `(${detail[0]})` : ''}暂时不支持使用该视频彩铃服务，敬请谅解！`;
                            Toast.fail({
                                message
                            });
                            reject(res.message);
                        }
                    }
                }).catch(err => {
                    Toast.clear();
                    dispatch('checkMobileTrack', { type: '11', res: err.message, isSuccess: false, carrierName: '' });
                    dispatch('handleActionApi', {
                        isp: '',
                        token: '',
                        phone: payload,
                        action: '11',
                        interfaceName: 'api/checkMobile',
                        resCode: 'err',
                        resMessage: `catcherr ${err.message}`
                    });
                });
            });
        },
        // 确认登陆态 我知道
        loginConfirm({ commit, state, rootState }) {
            window.localStorage.setItem('userInfo', JSON.stringify(rootState.app.userInfo));
            commit('app/SET_LOGIN_STATUS', true, { root: true });
            commit('ringtone/SET_SOURCE_CHANGE', '', { root: true });
            commit('ringtone/SET_TIPSHOW', false, { root: true });
            commit('ringtone/SET_HAS_CANCEL_ORDER', false, { root: true });
            // 清除切换运营标记
            // 跨浏览器标签通讯
            window.localStorage.setItem('tag-fresh', JSON.stringify({
                phone: state.phone,
                token: rootState.app.userInfo.TOKEN,
                carrierType: state.carrierType,
                sourceChange: false,
                loginStatus: rootState.app.loginStatus,
                date: new Date().getTime()
            }));
            window.localStorage.setItem('tag-home-fresh', JSON.stringify({
                phone: state.phone,
                token: rootState.app.userInfo.TOKEN,
                carrierType: state.carrierType,
                sourceChange: false,
                loginStatus: rootState.app.loginStatus,
                date: new Date().getTime()
            }));
        },
        // 确认号码页保留的
        getCarrierType({ dispatch, commit, state }) {
            return new Promise((resolve, reject) => {
                dispatch('checkMobileActions', state.phone)
                    .then(({ type }) => {
                    resolve(type);
                    commit('SET_CARRIER_TYPE', type);
                }).catch(err => {
                    reject(err);
                });
            });
        },
        handleActionApi({ rootState }, data) {
            sourceApi.actionlogApi({
                ...data,
                pid: rootState.app.selfInfo['dev-pid'],
                uid: rootState.app.selfInfo.uid,
                cookieId: rootState.app.cookieId
            });
        },
        checkMobileTrack(context, payload) {
            const { type, res, isSuccess, carrierName } = payload;
            if (res && res.data && res.data.detail) {
                const [province, city] = res.data.detail;
                const sensors = window.sensorsDataAnalytic201505;
                sensors.registerPage({
                    province,
                    city
                });
            }
            const params = {
                h5_color_ring_order_api_event_type: type,
                is_success: isSuccess || false,
                error_code: !isSuccess ? res.code || res.resCode || res.resultCode : '',
                error_msg: JSON.stringify(res),
                carrier_name: ''
            };
            console.log(params);
            if (carrierName) {
                params.carrier_name = CarrierType.ENUM[carrierName];
            }
            track([{ event_id: 'h5_color_ring_order_api_event', event_param: params }]);
        },
        // 设置前的判断
        settingPrepare({ state, dispatch, rootState, commit }) {
            if (Router.currentRoute.query.sourceType !== state.carrierType) {
                Toast.clear();
                queryRingRel({ phone: state.phone, ringId: state.settingData.videoId, pcid: Router.currentRoute.query.pcid }).then((res) => {
                    if (res.code === '0000') {
                        // 获取接口查询相同彩铃名称的资源
                        // 资源不一样返回之前的页面 然后切换资源
                        if (res.data.telecomDetailDto && state.carrierType === CarrierType.TELECOM) {
                            commit('SET_SETTING_VIDEOID', res.data.telecomDetailDto.ringId);
                            commit('SET_SETTING_PRODUCT_ID', res.data.telecomDetailDto.productid);
                            const videoId = res.data.telecomDetailDto.ringId;
                            const sourceTag = {
                                isSame: false,
                                sourceType: Router.currentRoute.query.sourceType,
                                videoId,
                                productId: res.data.telecomDetailDto.productid,
                                targeType: state.carrierType,
                                queryType: 1
                            };
                            window.localStorage.setItem('sourceTag', JSON.stringify(sourceTag));
                            dispatch('appStore/changeSourceRel', { videoId, queryType: 1 }, { root: true });
                            dispatch('handleOrder');
                        }
                        else if (res.data.mobileDetailDto && state.carrierType === CarrierType.MIGU) {
                            commit('SET_SETTING_VIDEOID', res.data.mobileDetailDto.ringId);
                            commit('SET_SETTING_CROPYRINGHT_ID', res.data.mobileDetailDto.packageId);
                            const videoId = res.data.mobileDetailDto.ringId;
                            const sourceTag = {
                                isSame: false,
                                sourceType: Router.currentRoute.query.sourceType,
                                videoId,
                                productId: res.data.mobileDetailDto.packageId,
                                targeType: state.carrierType,
                                queryType: 1
                            };
                            window.localStorage.setItem('sourceTag', JSON.stringify(sourceTag));
                            dispatch('appStore/changeSourceRel', { videoId, queryType: 1 }, { root: true });
                            dispatch('handleOrder');
                        }
                        else if (res.data.unicomDetailDto && state.carrierType === CarrierType.CUCC) {
                            commit('SET_SETTING_VIDEOID', res.data.unicomDetailDto.ringId);
                            const videoId = res.data.unicomDetailDto.ringId;
                            const sourceTag = {
                                isSame: false,
                                sourceType: Router.currentRoute.query.sourceType,
                                videoId,
                                targeType: state.carrierType,
                                queryType: 1
                            };
                            window.localStorage.setItem('sourceTag', JSON.stringify(sourceTag));
                            dispatch('appStore/changeSourceRel', { videoId, queryType: 1 }, { root: true });
                            dispatch('handleOrder');
                        }
                        else {
                            const sourceTag = {
                                isSame: false,
                                sourceType: Router.currentRoute.query.sourceType,
                                targeType: state.carrierType,
                                phone: state.phone
                            };
                            window.localStorage.setItem('sourceTag', JSON.stringify(sourceTag));
                            // const pageCount = state.historyPage.length ? state.historyPage.length : 1
                            // Router.go(-pageCount)
                            if (Router.currentRoute.query.tabType === 'tab-home') {
                                // window.close()
                                const query = {
                                    phone: state.phone,
                                    token: rootState.app.userInfo.TOKEN,
                                    carrierType: state.carrierType,
                                    sourceChange: true,
                                    loginStatus: rootState.app.loginStatus,
                                    date: new Date().getTime()
                                };
                                window.localStorage.setItem('tag-home-fresh', JSON.stringify(query));
                                exitPage();
                            }
                            else {
                                const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                Router.go(-pageCount);
                            }
                        }
                    }
                    else {
                        // commit('app/SET_USERINFO',{}, { root: true })
                        const sourceTag = {
                            isSame: false,
                            sourceType: Router.currentRoute.query.sourceType,
                            targeType: state.carrierType,
                            phone: state.phone
                        };
                        window.localStorage.setItem('sourceTag', JSON.stringify(sourceTag));
                        // const pageCount = state.historyPage.length ? state.historyPage.length : 1
                        // Router.go(-pageCount)
                        if (Router.currentRoute.query.tabType === 'tab-home') {
                            const query = {
                                phone: state.phone,
                                token: rootState.app.userInfo.TOKEN,
                                carrierType: state.carrierType,
                                sourceChange: true,
                                loginStatus: rootState.app.loginStatus,
                                date: new Date().getTime()
                            };
                            window.localStorage.setItem('tag-home-fresh', JSON.stringify(query));
                            exitPage();
                        }
                        else {
                            const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                            Router.go(-pageCount);
                        }
                    }
                });
            }
            else {
                dispatch('handleOrder');
            }
        },
        settingPrepareB({ state, dispatch, commit }, payload) {
            return new Promise((resolve) => {
                // 判断当前的playurl
                let srCarrierType = Router.currentRoute.query.sourceType;
                const { video } = payload;
                if (video.src) {
                    const isMigu = video.src.toLowerCase().includes('vod.migu.cn');
                    const isCucc = video.src.toLowerCase().includes('listen.10155.com');
                    const isTelecom = video.src.toLowerCase().includes('v.ctmus.cn');
                    if (isMigu) {
                        srCarrierType = CarrierType.MIGU;
                    }
                    else if (isCucc) {
                        srCarrierType = CarrierType.CUCC;
                    }
                    else if (isTelecom) {
                        srCarrierType = CarrierType.TELECOM;
                    }
                }
                if ((Router.currentRoute.query.sourceType !== state.carrierType) || (srCarrierType !== state.carrierType)) {
                    Toast.clear();
                    queryRingRel({ phone: state.phone, ringId: state.settingData.videoId, pcid: Router.currentRoute.query.pcid }).then((res) => {
                        if (res.code === '0000') {
                            // 获取接口查询相同彩铃名称的资源
                            // 资源不一样返回之前的页面 然后切换资源
                            if (res.data.telecomDetailDto && ((state.carrierType === CarrierType.TELECOM))) {
                                commit('SET_SETTING_VIDEOID', res.data.telecomDetailDto.ringId);
                                commit('SET_SETTING_PRODUCT_ID', res.data.telecomDetailDto.productid);
                                // const videoId = res.data.telecomDetailDto.ringId
                                // const query = {
                                //   ...Router.currentRoute.query,
                                //   // videoId: state.settingData.videoId,
                                //   sourceType: CarrierType.TELECOM,
                                //   targeType: state.carrierType,
                                //   from: 'changesource'
                                // }
                                // Router.replace({
                                //   name: 'details',
                                //   query
                                // })
                                dispatch('handleOrderB', payload);
                                resolve(true);
                            }
                            else if (res.data.mobileDetailDto && state.carrierType === CarrierType.MIGU) {
                                commit('SET_SETTING_VIDEOID', res.data.mobileDetailDto.ringId);
                                commit('SET_SETTING_CROPYRINGHT_ID', res.data.mobileDetailDto.packageId);
                                // const query = {
                                //   ...Router.currentRoute.query,
                                //   // videoId: state.settingData.videoId,
                                //   sourceType: CarrierType.MIGU,
                                //   targeType: state.carrierType,
                                //   from: 'changesource'
                                // }
                                // Router.replace({
                                //   name: 'details',
                                //   query
                                // })
                                // dispatch('appStore/changeSourceRel', { videoId, queryType: 1 }, { root: true })
                                //   .then(res => {
                                //     dispatch('handleOrder')
                                //   })
                                dispatch('handleOrderB', payload);
                                resolve(true);
                            }
                            else if (res.data.unicomDetailDto && ((state.carrierType === CarrierType.CUCC))) {
                                commit('SET_SETTING_VIDEOID', res.data.unicomDetailDto.ringId);
                                // const query = {
                                //   ...Router.currentRoute.query,
                                //   sourceType: CarrierType.CUCC,
                                //   targeType: state.carrierType,
                                //   from: 'changesource'
                                // }
                                // Router.replace({
                                //   name: 'details',
                                //   query
                                // })
                                dispatch('handleOrderB', payload);
                                resolve(true);
                            }
                            else {
                                const sourceTag = {
                                    isSame: false,
                                    sourceType: Router.currentRoute.query.sourceType,
                                    targeType: state.carrierType
                                };
                                window.localStorage.setItem('sourceTag', JSON.stringify(sourceTag));
                                resolve(false);
                            }
                        }
                        else {
                            debugger;
                            if (srCarrierType !== state.carrierType) {
                                const sourceTag = {
                                    isSame: false,
                                    sourceType: Router.currentRoute.query.sourceType ?? state.settingData.sourceType,
                                    targeType: state.carrierType
                                };
                                window.localStorage.setItem('sourceTag', JSON.stringify(sourceTag));
                                resolve(false);
                            }
                            else {
                                resolve(true);
                            }
                        }
                    });
                }
                else {
                    dispatch('handleOrderB', payload);
                    resolve(true);
                }
            });
        },
        // 只判断是否切换了
        settingPrepareC({ state, commit }, payload) {
            return new Promise((resolve) => {
                // 判断当前的playurl
                let srCarrierType = Router.currentRoute.query.sourceType;
                const { video } = payload;
                if (video.src) {
                    const isMigu = video.src.toLowerCase().includes('vod.migu.cn');
                    const isCucc = video.src.toLowerCase().includes('listen.10155.com');
                    const isTelecom = video.src.toLowerCase().includes('v.ctmus.cn');
                    if (isMigu) {
                        srCarrierType = CarrierType.MIGU;
                    }
                    else if (isCucc) {
                        srCarrierType = CarrierType.CUCC;
                    }
                    else if (isTelecom) {
                        srCarrierType = CarrierType.TELECOM;
                    }
                }
                if ((Router.currentRoute.query.sourceType !== state.carrierType) || (srCarrierType !== state.carrierType)) {
                    Toast.clear();
                    queryRingRel({ phone: state.phone, ringId: state.settingData.videoId, pcid: Router.currentRoute.query.pcid }).then((res) => {
                        if (res.code === '0000') {
                            // 获取接口查询相同彩铃名称的资源
                            // 资源不一样返回之前的页面 然后切换资源
                            if (res.data.telecomDetailDto && ((state.carrierType === CarrierType.TELECOM))) {
                                commit('SET_SETTING_VIDEOID', res.data.telecomDetailDto.ringId);
                                commit('SET_SETTING_PRODUCT_ID', res.data.telecomDetailDto.productid);
                                resolve(true);
                            }
                            else if (res.data.mobileDetailDto && state.carrierType === CarrierType.MIGU) {
                                commit('SET_SETTING_VIDEOID', res.data.mobileDetailDto.ringId);
                                commit('SET_SETTING_CROPYRINGHT_ID', res.data.mobileDetailDto.packageId);
                                resolve(true);
                            }
                            else if (res.data.unicomDetailDto && ((state.carrierType === CarrierType.CUCC))) {
                                commit('SET_SETTING_VIDEOID', res.data.unicomDetailDto.ringId);
                                resolve(true);
                            }
                            else {
                                const sourceTag = {
                                    isSame: false,
                                    sourceType: Router.currentRoute.query.sourceType,
                                    targeType: state.carrierType
                                };
                                window.localStorage.setItem('sourceTag', JSON.stringify(sourceTag));
                                resolve(false);
                            }
                        }
                        else {
                            if (srCarrierType !== state.carrierType) {
                                const sourceTag = {
                                    isSame: false,
                                    sourceType: Router.currentRoute.query.sourceType ?? state.settingData.sourceType,
                                    targeType: state.carrierType
                                };
                                window.localStorage.setItem('sourceTag', JSON.stringify(sourceTag));
                                resolve(false);
                            }
                            else {
                                resolve(true);
                            }
                        }
                    });
                }
                else {
                    resolve(true);
                }
            });
        },
        // 根据判断
        settingPrepareD({ state, dispatch, commit }, payload) {
            return new Promise((resolve) => {
                // 判断当前的playurl
                const srCarrierType = state.settingData.sourceType;
                if ((srCarrierType !== state.carrierType)) {
                    Toast.clear();
                    queryRingRel({ phone: state.phone, ringId: state.settingData.videoId, pcid: Router.currentRoute.query.pcid }).then((res) => {
                        if (res.code === '0000') {
                            // 获取接口查询相同彩铃名称的资源
                            // 资源不一样返回之前的页面 然后切换资源
                            if (res.data.telecomDetailDto && ((state.carrierType === CarrierType.TELECOM))) {
                                commit('SET_SETTING_VIDEOID', res.data.telecomDetailDto.ringId);
                                commit('SET_SETTING_PRODUCT_ID', res.data.telecomDetailDto.productid);
                                // const videoId = res.data.telecomDetailDto.ringId
                                // const query = {
                                //   ...Router.currentRoute.query,
                                //   // videoId: state.settingData.videoId,
                                //   sourceType: CarrierType.TELECOM,
                                //   targeType: state.carrierType,
                                //   from: 'changesource'
                                // }
                                // Router.replace({
                                //   name: 'details',
                                //   query
                                // })
                                dispatch('handleOrderB', payload);
                                resolve(true);
                            }
                            else if (res.data.mobileDetailDto && state.carrierType === CarrierType.MIGU) {
                                commit('SET_SETTING_VIDEOID', res.data.mobileDetailDto.ringId);
                                commit('SET_SETTING_CROPYRINGHT_ID', res.data.mobileDetailDto.packageId);
                                // const query = {
                                //   ...Router.currentRoute.query,
                                //   // videoId: state.settingData.videoId,
                                //   sourceType: CarrierType.MIGU,
                                //   targeType: state.carrierType,
                                //   from: 'changesource'
                                // }
                                // Router.replace({
                                //   name: 'details',
                                //   query
                                // })
                                // dispatch('appStore/changeSourceRel', { videoId, queryType: 1 }, { root: true })
                                //   .then(res => {
                                //     dispatch('handleOrder')
                                //   })
                                dispatch('handleOrderB', payload);
                                resolve(true);
                            }
                            else if (res.data.unicomDetailDto && ((state.carrierType === CarrierType.CUCC))) {
                                commit('SET_SETTING_VIDEOID', res.data.unicomDetailDto.ringId);
                                // const query = {
                                //   ...Router.currentRoute.query,
                                //   sourceType: CarrierType.CUCC,
                                //   targeType: state.carrierType,
                                //   from: 'changesource'
                                // }
                                // Router.replace({
                                //   name: 'details',
                                //   query
                                // })
                                dispatch('handleOrderB', payload);
                                resolve(true);
                            }
                            else {
                                const sourceTag = {
                                    isSame: false,
                                    sourceType: Router.currentRoute.query.sourceType,
                                    targeType: state.carrierType
                                };
                                window.localStorage.setItem('sourceTag', JSON.stringify(sourceTag));
                                resolve(false);
                            }
                        }
                        else {
                            if (srCarrierType !== state.carrierType) {
                                const sourceTag = {
                                    isSame: false,
                                    sourceType: Router.currentRoute.query.sourceType ?? state.settingData.sourceType,
                                    targeType: state.carrierType
                                };
                                window.localStorage.setItem('sourceTag', JSON.stringify(sourceTag));
                                resolve(false);
                            }
                            else {
                                resolve(true);
                            }
                        }
                    });
                }
                else {
                    dispatch('handleOrderB', payload);
                    resolve(true);
                }
            });
        },
        handleOrderB({ state, dispatch }, payload) {
            switch (state.carrierType) {
                case CarrierType.MIGU: {
                    dispatch('orderMIGU', { ...payload, isCurrentPageSetting: false, openOrder: true });
                    break;
                }
                case CarrierType.TELECOM: {
                    dispatch('orderTelecom', { ...payload, isCurrentPageSetting: false, openOrder: true });
                    break;
                }
                case CarrierType.CUCC: {
                    dispatch('orderCucc', { ...payload, isCurrentPageSetting: false, openOrder: true });
                }
            }
        },
        handleOrder({ state, dispatch }) {
            switch (state.carrierType) {
                case CarrierType.MIGU: {
                    dispatch('orderMIGU', false);
                    break;
                }
                case CarrierType.TELECOM: {
                    dispatch('orderTelecom', false);
                    break;
                }
                case CarrierType.CUCC: {
                    dispatch('orderCucc', false);
                }
            }
        },
        // 挽留弹窗的订购
        async retentionOrder({ commit, state, dispatch }) {
            const { videoId, productId, copyRightID, sourceType, desc } = state.retentionOrderParams;
            commit('SET_SETTING_SOURCETYPE', sourceType);
            commit('SET_SETTING_VIDEOID', videoId);
            commit('SET_SETTING_DESC', desc);
            commit('SET_SETTING_PRODUCT_ID', productId);
            commit('SET_SETTING_CROPYRINGHT_ID', copyRightID);
            switch (state.carrierType) {
                case CarrierType.MIGU: {
                    dispatch('orderMIGU', { isCurrentPageSetting: false, openOrder: true });
                    break;
                }
                case CarrierType.TELECOM: {
                    dispatch('orderTelecom', { isCurrentPageSetting: false, openOrder: true, isNoComfirn: true });
                    break;
                }
                case CarrierType.CUCC: {
                    dispatch('orderCucc', { isCurrentPageSetting: false, openOrder: true, isNoComfirn: true });
                    break;
                }
            }
        }
    }
};
export default ringTone;
